import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching credit notes
export const fetchCreditNotes = createAsyncThunk(
    "creditNote/fetch",
    async (_, { rejectWithValue }) => {
        try {
            // Call the API to fetch credit notes
            const response = await request({
                endpoint: "/admin/getAllCreditNote", // API endpoint
                method: "GET"
            });

            console.log("Fetch Credit Notes Response:", response);

            // Check if the fetch operation was successful
            if (!response.data || !Array.isArray(response.data)) {
                return rejectWithValue(response.message || "Failed to fetch credit notes.");
            }

            // Return the fetched credit notes
            return response.data;
        } catch ({ error }) {
            console.error("Error fetching credit notes:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching credit notes.");
        }
    }
);
export const uploadCreditNote = createAsyncThunk(
    "creditNote/upload",
    async ({ file }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("creditNote", file);

            const response = await request({
                endpoint: "/admin/uploadCreditNote",
                method: "POST",
                body: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });
            console.log("Upload Credit Note Response:", response);
            if (!response.success) {
                return rejectWithValue(response.error || "Failed to upload credit note.");
            }

            return response?.data[0]?.creditNotes;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to upload credit note.");
        }
    }
)
const initialState = {
    creditNotes: [], // Array to store all credit notes
    loading: false,
    error: null,
};

const creditNoteSlice = createSlice({
    name: "creditNote",
    initialState,
    reducers: {
        addCreditNotes: (state, action) => {
            state.creditNotes = action.payload;
        },
        clearCreditNotes: (state) => {
            state.creditNotes = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Credit Notes
            .addCase(fetchCreditNotes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCreditNotes.fulfilled, (state, action) => {
                state.loading = false;
                state.creditNotes = action.payload; // Update the credit notes array
            })
            .addCase(fetchCreditNotes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            })
            //upload credit note
            .addCase(uploadCreditNote.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(uploadCreditNote.fulfilled, (state, action) => {

                state.loading = false;
                action?.payload?.forEach((creditNote) => {
                    state.creditNotes.push(creditNote);
                });

            })
            .addCase(uploadCreditNote.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { clearCreditNotes, addCreditNotes } = creditNoteSlice.actions;
export default creditNoteSlice.reducer;
